import type { Account } from '@/types/serializers'
import AccountLayout from './_layout/AccountLayout.tsx'
import CompetitiveAnalysisTab from './_tabs/CompetitiveAnalysisTab'

interface CompetitiveProps {
    account: Account
}

export default function AccountCompetitive({account}: CompetitiveProps) {
    return (
        <AccountLayout account={account} activeTab="competitive">
            <CompetitiveAnalysisTab account={account}/>
        </AccountLayout>
    )
}